import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

import { IIncentiveParamsNumberOfEntries } from "./incentive-params-number-of-entries.interface";

export class IncentiveParamsNumberOfEntriesDto
  implements IIncentiveParamsNumberOfEntries
{
  @IsOptional()
  show_type?: string;

  @IsNotEmpty()
  @IsNumber()
  number_of_entries: number;

  @IsNotEmpty()
  @IsNumber()
  fee: number;

  @IsOptional()
  @IsNumber()
  early_bird_fee?: number;
}
